import React from 'react';
import { PlayBadge, THEMES } from '../../../../PlayBadge/PlayBadge';

const NextBadge = ({ next, broadcastedNow }) => {
    if (!next || broadcastedNow) {
        return null;
    }

    return <PlayBadge text="Nästa" accessibilityText="Nästa avsnitt" theme={THEMES.DEFAULT} overlay />;
};

export default NextBadge;
